module.exports = __webpack_public_path__ + "img/admin-background-icon.a8d35d09.png";